import { useLocalObservable } from 'mobx-react-lite';
import { useNavigate, useParams } from 'react-router-dom';

import { DeepLinkType } from '@gem/models/deeplinksModel';
import { platformInfo } from '@gem/utils';

import { RouterLink, RouterParams } from 'APP/router/constants';
import { UnauthorizedRouts } from 'APP/unauthorized/UnauthorizedView.constants';
import { ProjectName } from 'CONFIG_TYPES';

import { ISetView, ViewType } from '../CallInvitation.types';

interface IJoinBlockPresenter {
  onJoinAsUserClick: () => void;
  changeView: () => void;
  isShowJoinAsUserButton: boolean;
  isShowLogo: boolean;
}

export const useJoinBlockPresenter = (setView: ISetView): IJoinBlockPresenter => {
  const navigate = useNavigate();
  const params = useParams();

  const presenter = useLocalObservable<IJoinBlockPresenter>(() => ({
    onJoinAsUserClick(): void {
      const queryParams = new URLSearchParams({
        [RouterParams.deepLink]: 'true',
        [RouterParams.channelId]: params.channelId!,
        [RouterParams.type]: DeepLinkType.Room,
      });

      navigate(
        `${RouterLink.Unauthorized}/${
          UnauthorizedRouts.CallInvitationLogin
        }?${queryParams.toString()}`,
        { replace: true }
      );
    },
    changeView(): void {
      setView(ViewType.NameView);
    },
    get isShowJoinAsUserButton(): boolean {
      return !platformInfo.isMobile;
    },
    get isShowLogo(): boolean {
      return PROJECT_NAME === ProjectName.Gemteam;
    },
  }));

  return presenter;
};
